import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Node_Type, validate, mergeStyles } from 'wix-rich-content-common';
import pluginGiphySchema from 'wix-rich-content-common/dist/statics/schemas/plugin-giphy.schema.json';
import { isEqual } from 'lodash';

var styles = {"giphy_player":"aERFs"};

var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const DEFAULTS = Object.freeze({
  config: {
    size: "content",
    alignment: "center"
  },
  configViewer: {
    sizes: { desktop: "original", mobile: "original" }
    // original or downsizedSmall are supported
  }
});
const commonDesktopModalStyles = {
  width: "320px",
  boxSizing: "border-box",
  height: "364px",
  overflow: "visible",
  paddingRight: "12px",
  paddingLeft: "12px",
  display: "block",
  position: "absolute",
  zIndex: 6,
  paddingTop: "12px"
};
Object.freeze({
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0)",
    zIndex: 5
  },
  content: __spreadProps(__spreadValues$1({}, commonDesktopModalStyles), {
    border: "solid 1px rgba(51, 51, 51, 0.1)",
    boxShadow: "var(--ricos-settings-whitebox-box-shadow, 0 0 10px 0 rgba(0, 0, 0, 0.06))",
    borderRadius: "var(--ricos-settings-whitebox-border-radius, 2px)"
  })
});
({
  insert: `${Node_Type.GIF}.insert`,
  replace: `${Node_Type.GIF}.replace`
});
({
  alignment: `${Node_Type.GIF}.alignment`,
  size: `${Node_Type.GIF}.size`
});

class GiphyViewer extends Component {
  constructor(props) {
    super(props);
    validate(props.componentData, pluginGiphySchema);
  }
  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.componentData, this.props.componentData)) {
      validate(nextProps.componentData, pluginGiphySchema);
    }
  }
  render() {
    this.styles = this.styles || mergeStyles({ styles, theme: this.props.theme });
    const { componentData, setComponentUrl } = this.props;
    const { gif } = componentData;
    if (!gif.originalMp4 && !gif.originalUrl) {
      return null;
    }
    setComponentUrl == null ? void 0 : setComponentUrl(gif.originalMp4 ? gif.originalMp4 : gif.originalUrl);
    if (gif.originalMp4) {
      return (
        // video should be treated as an noninteractive git element
        /* eslint-disable jsx-a11y/no-redundant-roles, jsx-a11y/no-interactive-element-to-noninteractive-role*/
        /* @__PURE__ */ React.createElement(
          "video",
          {
            role: "img",
            autoPlay: true,
            muted: true,
            loop: true,
            playsInline: true,
            "aria-label": "gif",
            className: this.styles.giphy_player,
            src: gif.originalMp4
          }
        )
      );
    }
    return /* @__PURE__ */ React.createElement(
      "img",
      {
        role: "img",
        "aria-label": "gif",
        className: this.styles.giphy_player,
        src: gif.originalUrl,
        alt: "gif"
      }
    );
  }
}
GiphyViewer.propTypes = {
  componentData: PropTypes.object.isRequired,
  onReady: PropTypes.func,
  onStart: PropTypes.func,
  controls: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  settings: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  setComponentUrl: PropTypes.func
};
GiphyViewer.defaultProps = {
  width: "100%",
  height: "100%",
  controls: true
};
var GiphyViewer$1 = GiphyViewer;

const GIPHY_TYPE = "wix-draft-plugin-giphy";

const typeMapper = () => ({
  [GIPHY_TYPE]: { component: GiphyViewer$1 }
});

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginGiphy = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.configViewer), config),
    type: GIPHY_TYPE,
    typeMapper
    // nodeViewRenderers,
  };
};

export { GIPHY_TYPE, typeMapper as giphyTypeMapper, pluginGiphy };
//# sourceMappingURL=viewer.js.map

import 'wix-rich-content-plugin-giphy/dist/es/styles.viewer.min.global.css'